export default __webpack_public_path__ + "static/media/lanvest.1b10a810.png";